import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../components/layout/Layout";
// import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function ContactUs() {
    const [formData, setFormData] = useState({
        content: "",
        email: "",
        phone: ""
    });
    const [disableBtn, setDisableBtn] = useState(false);
    //   const navigate = useNavigate(null);

    const handleInputChange = (eOrVal) => {
        // If the input is from ReactQuill (it returns just the value)
        if (typeof eOrVal === "string") {
            setFormData({ ...formData, content: eOrVal });
        } else {
            const { name, value } = eOrVal.target;
            setFormData({ ...formData, [name]: value });
        }
    };

    useEffect(() => {
        getContent();
    }, [])

    const getContent = async () => {
        try {
            const token = localStorage.getItem("sansadToken");
            // const headers = {
            //   authorization: `Bearer ${token}`,
            //   "Content-Type": "application/json",
            // };

            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/contact-us/get-contact-us`,
                // {
                //   headers: headers,
                // }
            );

            console.log("Response", response);

            if (response.data.statusCode === 200) {
                setFormData({
                    content: response.data.result.content,
                    email: response.data.result.email,
                    phone: response.data.result.phone
                })
            } else {
                toast.error(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setDisableBtn(true);

            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };
            const formdata = new FormData();
            formdata.append("content", formData.content);
            formdata.append("email", formData.email);
            formdata.append("phone", formData.phone);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/contact-us/create-contact-us`,
                formData,
                {
                    headers: headers,
                }
            );
            if (response.data.statusCode === 200) {
                toast.success("Contact Us updaed successfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error(response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            console.log(error);
        }
        setDisableBtn(false);
    };

    return (
        <Layout>
            <div>
                <ToastContainer />
                <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-medium">Contact Us</h2>
                    </div>
                    <div className="w-full mt-10">
                        <form action="" className="w-full" onSubmit={handleSubmit}>
                            {/* Email */}
                            <div className="flex flex-col md:flex-row gap-4 mb-4">
                                {/* Email */}
                                <div className="w-full md:w-1/2">
                                    <label className="block mb-1 font-medium">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email || ""}
                                        onChange={handleInputChange}
                                        className="w-full border rounded-md px-4 py-2"
                                        required
                                    />
                                </div>

                                {/* Phone */}
                                <div className="w-full md:w-1/2">
                                    <label className="block mb-1 font-medium">Phone</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone || ""}
                                        onChange={handleInputChange}
                                        className="w-full border rounded-md px-4 py-2"
                                        required
                                    />
                                </div>
                            </div>


                            {/* Rich Text Editor */}
                            <div>
                                <h2 className="mb-2">Write Below</h2>
                                <ReactQuill
                                    theme="snow"
                                    value={formData.content}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Submit Button */}
                            <div className="mt-10">
                                <button
                                    type="submit"
                                    className="rounded-md h-[46px] w-full bg-[#2c2c38] text-white hover:bg-[#191919]"
                                    disabled={disableBtn}
                                >
                                    {disableBtn ? "Please Wait ..." : "Save"}
                                </button>
                            </div>

                            {/* Preview */}
                            <div className="mt-5">
                                <h3 className="mb-3">Preview:</h3>

                                <div dangerouslySetInnerHTML={{ __html: formData.content }} />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );

}
